import dashboard from './dashboard';
import masterManagement from './masterManagement';
import reports from './reports';
import bets from './bets';
import subOwners from './subOwners';
import odds from './odds';
import test from './test';
// ==============================|| MENU ITEMS ||============================== //
// {'test.*': test},
const mapAccess = [{'dashboard.*': dashboard},{'master.*': masterManagement},{'subowner.*': subOwners},{'odds.*': odds},{'reports.*': reports},{'bets.*': bets}]

const storedAccess = JSON.parse(localStorage.getItem('access'))?.split(',');


let filteredAccess = mapAccess
  .filter((access) => {
    const key = Object.keys(access)[0];
    return storedAccess?.includes(key);
  })
  .map((access) => Object.values(access)[0]);

  if(filteredAccess.length == 0){
    filteredAccess = mapAccess.map((access) => Object.values(access)[0]);
  }

const menuItems = {
    // items: [dashboard, masterManagement, reports, bets]
    items: filteredAccess
};

export default menuItems;
